import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
// import "antd/dist/antd.css";
import "antd/dist/antd.min.css";

// Ant Design can trigger this harmless browser scheduling warning while a
// responsive component is resizing. Keep it out of the development overlay;
// real runtime errors are still allowed through.
if (process.env.NODE_ENV === "development") {
  const isResizeObserverWarning = (message) =>
    String(message || "").includes("ResizeObserver loop");

  const handleResizeObserverError = (event) => {
    if (isResizeObserverWarning(event?.message)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  };

  // The dev overlay can receive this browser notification through either
  // the error event or window.onerror, depending on the browser version.
  window.addEventListener("error", handleResizeObserverError, true);
  const previousOnError = window.onerror;
  window.onerror = (message, source, lineno, colno, error) => {
    if (isResizeObserverWarning(message)) return true;
    return typeof previousOnError === "function"
      ? previousOnError(message, source, lineno, colno, error)
      : false;
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<App />);
// <React.StrictMode>
// </React.StrictMode>

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
